import AuthenticationActionTypes from "services/authentication/types";
import ContractActionTypes from "services/contract/types";
import MapActionTypes from "./types";

const initialState = {
  config: {
    default_position: undefined,
    default_zoom: undefined,
    max_zoom_allowed: undefined,
    min_zoom_allowed: undefined,
    tiles_url: undefined,
    heatmap_occupancy: undefined,
    currentZoom: undefined,
    currentPosition: undefined,
    currentRadius: undefined,
    currentFloor: undefined,
    aislesDisplayed: false,
    labelsDisplayed: true,
    displaysDisplayed: true,
    spaceLabelsDisplayed: true,
  },
  initialized: false,
};

const MapReducer = (state = initialState, action) => {
  switch (action.type) {
    case AuthenticationActionTypes.LOG_OUT:
    case ContractActionTypes.SWITCH_CONTRACT:
      return initialState;
    case MapActionTypes.SET_INITIALIZED:
      return {
        ...state,
        initialized: true,
      };
    case MapActionTypes.SET_CONFIG:
      return {
        ...state,
        config: {
          ...state.config,
          ...action.value,
        },
      };
    case MapActionTypes.SET_CONFIG_PARAM:
      return {
        ...state,
        config: {
          ...state.config,
          [action.key]: action.value,
        },
      };
    default:
      return state;
  }
};

export default MapReducer;
